import { render } from "./DeleteProfileFlow.vue?vue&type=template&id=f153801e"
import script from "./DeleteProfileFlow.vue?vue&type=script&lang=js"
export * from "./DeleteProfileFlow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__